export default __webpack_public_path__ + "static/media/WDCM5.f617da96.jpg";